import companiesActionTypes from './action-types';

export const fetchAddOrEditCompanySubmission = payload => ({
  type: companiesActionTypes.FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION,
  payload,
});

export const fetchAddOrEditCompanySubmissionSuccess = payload => ({
  type: companiesActionTypes.FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddOrEditCompanySubmissionFail = payload => ({
  type: companiesActionTypes.FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_FAIL,
  payload,
});
